module.exports = __webpack_public_path__ + "static/media/nursingliquid1.7aa15c23.jpg";